import { render } from "./Carrinho.vue?vue&type=template&id=ef85b2d4"
import script from "./Carrinho.vue?vue&type=script&lang=js"
export * from "./Carrinho.vue?vue&type=script&lang=js"

import "./Carrinho.vue?vue&type=style&index=0&id=ef85b2d4&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__